import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'
import type { KambiBetOffer, KambiEvent, KambiPrePack } from '@mobi/api-types/kambi'

export const getKambiBetOffersByIds = ({ betOfferIds }: { betOfferIds: number[] }) =>
  simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/${betOfferIds.join(',')}?lang=en_AU&market=AU`
  )

export const getKambiBetOffersByEventIds = ({
  eventIds,
}: {
  eventIds: (number | string)[]
}): Promise<KambiBetOffersByIdsResponse> => {
  if (eventIds.length === 0) {
    return Promise.resolve({
      betOffers: [],
      events: [],
      prePacks: [],
      range: { start: 0, size: 0, total: 0, hasNext: false },
    })
  }
  return simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/event/${eventIds.join(',')}?lang=en_AU&market=AU&includeParticipants=true`
  )
}

export const getKambiBetOffersByGroupIds = ({
  groupIds,
}: {
  groupIds: (number | string)[]
}): Promise<KambiBetOffersByIdsResponse> => {
  if (groupIds.length === 0) {
    return Promise.resolve({
      betOffers: [],
      events: [],
      prePacks: [],
      range: { start: 0, size: 0, total: 0, hasNext: false },
    })
  }
  return simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/group/${groupIds.join(',')}?lang=en_AU&market=AU&includeParticipants=true`
  )
}

export const getKambiBetOffersByOutcomeIds = ({
  outcomeIds,
}: {
  outcomeIds: (number | string)[]
}): Promise<KambiBetOffersByIdsResponse> => {
  if (outcomeIds.length === 0) {
    return Promise.resolve({
      betOffers: [],
      events: [],
      prePacks: [],
      range: { start: 0, size: 0, total: 0, hasNext: false },
    })
  }
  return simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/outcome?id=${outcomeIds.join('&id=')}&lang=en_AU&market=AU&includeParticipants=false&range_size=1000`
  )
}
// =====
// Types
// =====

type KambiBetOffersByIdsResponse = {
  betOffers: KambiBetOffer[]
  events: KambiEvent[]
  prePacks: KambiPrePack[]
  range?: {
    start: number
    size: number
    total: number
    hasNext: boolean
  }
}
